document.addEventListener("DOMContentLoaded", function() {
    //Nombre d'enfants
    let inputChildNumber = document.querySelector('#childNumber');
    let inputChildChargeNumber = document.querySelector('#childChargeNumber');
    if (inputChildNumber){
        childInput();
        inputChildNumber.addEventListener('change',(e) =>{
            childInput();
        });
    }
    function childInput(){
        if (inputChildNumber.value && inputChildNumber.value > 0){
            inputChildChargeNumber.parentNode.style.display = "block";
        } else {
            inputChildChargeNumber.parentNode.style.display = "none";
        }
    }

    //Emploi / indépendant
    let status = document.querySelector('#status');
    let noJob = document.querySelector('#timeWithoutJob');
    let independant = document.querySelector('#timeIndependant');
    let entrepriseNumber = document.querySelector('#entrepriseNumber');
    if (status){
        statusInput();
        status.addEventListener('change',(e) =>{
            statusInput();
        });
    }
    function statusInput(){
        if (status.value && status.value == 5){
            independant.parentNode.style.display = "block";
            entrepriseNumber.parentNode.style.display = "block";
            noJob.parentNode.style.display = "none";
        }
        else if(status.value && status.value >= 0 && status.value < 5){
            noJob.parentNode.style.display = "block";
            independant.parentNode.style.display = "none";
            entrepriseNumber.parentNode.style.display = "none";
        }
        else {
            independant.parentNode.style.display = "none";
            entrepriseNumber.parentNode.style.display = "none";
            noJob.parentNode.style.display = "none";
        }
    }

    //Financement
    let financementQ1 = document.querySelector('#financementQ1');
    let financementQ2 = document.querySelector('#financementQ2');
    if (financementQ1 && financementQ2){
        financementInput();
        financementQ1.addEventListener('change',(e) =>{
            financementInput();
        });
    }
    function financementInput(){
        if (financementQ1.value && financementQ1.value === 'oui'){
            financementQ2.parentNode.style.display = "block";
        } else{
            financementQ2.parentNode.style.display = "none";
        }
    }

    //Jobin
    let jobinQ2 = document.querySelector('#jobinQ2');
    let jobinQ3 = document.querySelector('#jobinQ3');
    if (jobinQ2 && jobinQ3){
        jobinInput();
        jobinQ2.addEventListener('change',(e) =>{
            jobinInput();
        });
    }
    function jobinInput(){
        if (jobinQ2.value && jobinQ2.value === 'oui'){
            jobinQ3.parentNode.style.display = "block";
        } else{
            jobinQ3.parentNode.style.display = "none";
        }
    }
});